import React from "react";
import { BRAND } from "../../../utils/chartTheme";

const BOQSummaryCard = ({ stats }) => {
  // Activity Type Card Component
  const ActivityTypeCard = ({ title, count, variant = "default" }) => {
    const borderColors = {
      default: "#ededed",
      surveyed: BRAND.teal,
      approved: BRAND.teal,
      pending: BRAND.teal,
    };
    const borderColor = borderColors[variant] || borderColors.default;

    return (
      <div>
        <div
          className="bg-[#f7f7f7] text-white h-28 p-2.5 rounded-3xl border-2 hover:border-teal-300 transition-all duration-300 hover:shadow-md"
          style={{ borderColor }}
        >
          <h3 className="text-2xl text-center mt-4 mb-0 text-[#3A3A3A] p-0 font-bold text-balance">
            {count ?? 0}
          </h3>
          <h6 className="text-xs text-center p-0 m-0 text-[#787878] font-semibold">
            {title}
          </h6>
        </div>
      </div>
    );
  };

return (
  <div className="text-center w-full">
    {/* <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
      BOQ Summary ({stats.totalBoqsFormatted})
    </h3> */}

    {/* 3 cards in one row */}
    <div className="grid grid-cols-3 gap-1">
      <ActivityTypeCard
        title="Total BOQs"
        count={stats.totalBoqsFormatted}
        variant="approved"
      />
      <ActivityTypeCard
        title="Total Cost"
        count={stats.totalCostFormatted}
        variant="pending"
      />
      <ActivityTypeCard
        title="Avg per BOQ"
        count={stats.avgCostPerBoqFormatted}
        variant="surveyed"
      />
    </div>
  </div>
);


};

export default BOQSummaryCard;
